exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field[data-v-2d2ef884] {\n  display: flex;\n}\n.field.column[data-v-2d2ef884] {\n  flex-direction: column;\n  padding: 0 10px;\n}\n.field.column label[data-v-2d2ef884] {\n  margin-left: 0;\n  padding-left: 0;\n}\n.field label[data-v-2d2ef884] {\n  width: auto;\n  display: block;\n  margin-right: 10px;\n}", ""]);

// exports
